// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  ok: 'OK',
  cancel: 'Cancel',
  update: 'Update',
  save: 'Save',
  back: 'Back',
  role: 'Role',
  profile: 'Profile',
  address: 'Address',
  city: 'City',
  country: 'Country',
  postcode: 'Postcode',
  address_line: 'Address line {number}',
  flat_number_building: 'Flat Number/Building',
  street_name: 'Street Name',
  language: 'Language',
  setting: 'Setting',
  discount: 'Discount',
  error: 'Error',
  name: 'Name',
  unit: 'Unit',
  price: 'Price',
  plu: 'PLU',
  variant: 'Variant',
  buy: 'Buy',
  add_qty: 'Add Qty',
  get: 'Get',
  free: 'Free',
  with: 'With',
  off: 'Off',
  quick_tip: 'Quick Tip',
  quick_tips: 'Quick Tips',
  sales_unit: 'Sales Unit',
  default_price: 'Default Price',
  category_name: 'Category Name',
  category: 'Category',
  categories: 'Categories',
  item_name: 'Item Name',
  item_type: 'Item Type',
  customer: 'Customer',
  customers: 'Customers',
  id: 'ID',
  email: 'Email',
  email_address: 'Email Address',
  password: 'Password',
  active: 'Active',
  on_hold: 'On Hold',
  date_of_birth: 'Date of Birth',
  delete: 'Delete',
  close: 'Close',
  archive: 'Archive',
  image: 'Image',
  currency: 'Currency',
  description: 'Description',
  next: 'Next',
  branch: 'Branch',
  branches: 'Branches',
  gender: 'Gender',
  genders: {
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  titles: {
    mr: 'Mr.',
    mrs: 'Mrs.',
    ms: 'Ms.',
    miss: 'Miss',
    mx: 'Mx.',
    dr: 'Dr.',
    prof: 'Prof.',
    sir: 'Sir',
    lady: 'Lady',
  },
  title: 'Title',
  status: 'Status',
  first_name: 'First Name',
  last_name: 'Last Name',
  optional: 'Optional',
  contact_number: 'Contact Number',
  note: 'Note',
  staff: 'Staff',
  modifier: 'Modifier',
  item: 'Item',
  items: 'Items',
  min_required: 'Min Required',
  max_allowed: 'Max Allowed',
  minimum_required: 'Minimum Required',
  maximum_allowed: 'Maximum Allowed',
  min_qty: 'Min Qty',
  max_qty: 'Max Qty',
  default_qty: 'Default Qty',
  inventory_item: 'Inventory Item',
  link_branches: 'link Branches',
  non_inventory_item: 'Non-Inventory Item',
  modifier_category: 'Modifier Category',
  connected_modifier_group: 'Connected Modifier Group',
  allergens: 'Allergens',
  no_data: {
    item: {
      title: 'No item has been created!',
      description: 'You need to create items to be able to add them here.',
    },
  },
  item_kinds: {
    goods_for_sale: 'Goods for Sales',
    service: 'Service',
    menu_item: 'Menu Item',
    supplies: 'Supplies',
    meal_deal: 'Meal Deal',
  },
  inventory_management: 'Inventory Management',
  delete_warning: 'Are You Sure You want to delete this?',
  add_name: 'Add Name',
  inventory_location: 'Inventory Location',
  sku: 'SKU',
  value_required: 'Value required',
  not_available: 'Not Available',
  connect: 'Connect',
  connected: 'Connected',
  hello: 'Hello',
  branch_name: 'Branch Name',
}
